import type { BaseLogParam } from '../types';
import type { MetricsMap } from './types';

export abstract class MetricCollector<T1 = unknown, T2 = T1, T3 = T1> {
  metrics: MetricsMap<T1, T2, T3>;

  constructor() {
    this.metrics = this.getFreshMetrics();
  }

  getFreshMetrics(): MetricsMap<T1, T2, T3> {
    return {
      counters: {},
      timers: {},
      levels: {},
    };
  }

  isEmpty(): boolean {
    return (
      !Object.keys(this.metrics.counters).length &&
      !Object.keys(this.metrics.timers).length &&
      !Object.keys(this.metrics.levels).length
    );
  }

  /** Clear out all stored metrics */
  clearMetrics(): void {
    this.metrics = this.getFreshMetrics();
  }

  abstract addHistogram({ metricsName, dimensions, value }: BaseLogParam & { value: number }): void;
  abstract addTimer({
    metricsName,
    dimensions,
    milliSec,
  }: BaseLogParam & { milliSec: number }): void;
  abstract getPayload(): Uint8Array;
  abstract increment({ metricsName, dimensions, value }: BaseLogParam & { value: number }): void;
}
